<template>
  <text-box :label="label" :icon="icon" :color="color">
    <template v-slot:info>
      <slot name="info"></slot>
    </template>
    <template v-slot:info-dialog>
      <slot name="info-dialog"></slot>
    </template>
    <div class="metric-container">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div class="d-flex justify-center" style="font-size: 28px;" v-on="on">{{ formattedValue.toString() === 'NaN' ? $t('components.TextBoxMetric.notAvailable') : formattedValue }}</div>
        </template>
        {{ fullValue }}
      </v-tooltip>
      <div v-if="caption" class="d-flex justify-center grey--text caption">{{ caption }}</div>
      <v-sparkline v-if="sparkline.length > 0" :value="sparkline" smooth="10" gradient-direction="top" type="trend" auto-draw auto-line-width height="50"></v-sparkline>
    </div>
  </text-box>
</template>

<script>
import TextBox from '@/components/TextBox.vue'
import numbro from 'numbro'

export default {
  components: {
    TextBox
  },
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    unit: {
      type: String,
      default: '',
      required: false
    },
    caption: {
      type: String,
      default: '',
      required: false
    },
    unitAfterValue: {
      type: Boolean,
      default: false,
      required: false
    },
    icon: {
      type: String,
      default: 'chart-bubble',
      required: false
    },
    color: {
      type: String,
      required: false
    },
    sparkline: {
      type: Array,
      default: () => [],
      required: false
    }
  },
  computed: {
    formattedValue: function () {
      const valueString = this.formatValue(this.value)
      if (this.unitAfterValue) {
        return `${valueString} ${this.unit}`
      } else {
        return `${this.unit}${valueString}`
      }
    },
    fullValue: function () {
      const valueString = this.formatFullValue(this.value)
      if (this.unitAfterValue) {
        return `${valueString} ${this.unit}`
      } else {
        return `${this.unit}${valueString}`
      }
    }
  },
  methods: {
    formatValue: function (value) {
      return numbro(value).format({
        average: true,
        lowPrecision: false,
        mantissa: 1,
        optionalMantissa: true
      })
    },
    formatFullValue: function (value) {
      return numbro(value).format({
        thousandSeparated: true
      })
    }
  }
}
</script>

<style scoped>
.metric-container {
  padding: 8px;
}
</style>
